import request from "@/utils/request";

export function getExhibitions(hallId) {
  let params = {
    hallId: hallId,
  };
  return request({
    url: `/api/Exhibitions/GetExhibitions/${hallId}`,
    method: `get`,
    params,
  });
}

export function getExhibitionId(id, params) {
  return request({
    url: `/api/Exhibitions/GetExhibition/${id}`,
    method: `get`,
    params,
  });
}

export function putExhibition(id, data, params) {
  if (Array.isArray(data.audioLink)) {
    data.audioLink = data.audioLink[0].response;
  }
  return request({
    url: `/api/Exhibitions/UpdateExhibition/${id}`,
    method: `post`,
    params,
    data,
  });
}

export function postExhibition(data, params) {
  if (data.audioLink) {
    data.audioLink = data.audioLink[0].response;
  }
  return request({
    url: `/api/Exhibitions/AddExhibition/${params.hallId}`,
    method: `post`,
    params,
    data,
  });
}

export function deleteExhibition(id, params) {
  return request({
    url: `/api/Exhibitions/DeleteExhibition/${id}`,
    method: "delete",
    params,
  });
}
